// extracted by mini-css-extract-plugin
export default {"imageStyles":"ErrorCustom_imageStyles__lriOI","boxStyles":"ErrorCustom_boxStyles__3OpUQ","heading":"ErrorCustom_heading__ueIJI","text":"ErrorCustom_text__VwFOL"};